import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  channel_id:any
  channel_data:any
  constructor(private apiService:ApiService,
    private activatedroute:ActivatedRoute,
    ) { 
    this.activatedroute.paramMap.subscribe(params => { 
    this.channel_id = params.get('id');      
    });
  }

  ngOnInit(): void {
    this.getJobById()
  }
  getJobById(){
    this.apiService.getChannelById(this.channel_id).subscribe((res:any)=>{
      if(res.statusCode == 200){
        this.channel_data=res.data
      }
    })
  }

}
